import { Injectable } from '@angular/core';
import { API_URL } from 'common/constants/sm-constants';
import { ApplicantsModel } from 'common/models/page-models/applicants/applicant-table/applicant-grid.model';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { DataService } from '../../base-data-services/data.service';

@Injectable()
export class ApplicantDocumentListDataService extends DataService<ApplicantsModel> {
  constructor(protected ss: SystemService, protected http: SmApiService) {
    super(ss, API_URL.getApplicantDocumentList, http);
  }

  //    override getAPI_URL(): API_URL {
  //         return API_URL.getDocumentTypeList;
  //       }

  createInstance(): ApplicantsModel {
    return new ApplicantsModel();
  }
}
